"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonitorCreatedEvent = void 0;
const applicationEvent_1 = require("./applicationEvent");
class MonitorCreatedEvent extends applicationEvent_1.ApplicationEvent {
    constructor(monitorId, organizationId) {
        super(false, organizationId);
        this.monitorId = monitorId;
        this.organizationId = organizationId;
    }
    getMessageType() {
        return applicationEvent_1.ApplicationEventType.MONITOR_CREATED;
    }
    getExchangeName() {
        return applicationEvent_1.ApplicationEventExchangeName.MONITOR_CREATED;
    }
}
exports.MonitorCreatedEvent = MonitorCreatedEvent;
